import { Link } from "react-router-dom";
import Icon from "./Icon";
import StatusBadge from "./StatusBadge";
import { carPath, carStatus, carTitle, formatKm, formatPrice, priceWithoutVat } from "../lib/format";
import s from "./CarCard.module.css";

export default function CarCard({ car }) {
  const status = carStatus(car);
  const images = car.images || [];

  return (
    <Link to={carPath(car)} className={`${s.card} ${s[status]}`}>
      <div className={s.media}>
        {images[0]
          ? <img src={images[0]} alt="" loading="lazy" />
          : <div className={s.noImage}><Icon name="image" size={28} /></div>}
        {status !== "available" && <StatusBadge status={status} className={s.badge} />}
        {images.length > 1 && (
          <span className={s.count}><Icon name="image" size={14} />{images.length}</span>
        )}
      </div>

      <div className={s.body}>
        <h3 className={s.title}>{carTitle(car)}</h3>
        <p className={s.meta}>
          {car.year && <strong className={s.year}>{car.year}</strong>}
          {car.year && car.color && " · "}
          {car.color}
        </p>

        <dl className={s.specs}>
          <div><dt>Baterie</dt><dd>{car.battery || "—"}</dd></div>
          <div><dt>Dojezd</dt><dd>{car.range ? formatKm(car.range) : "—"}</dd></div>
          <div><dt>Nájezd</dt><dd>{formatKm(car.mileage)}</dd></div>
          <div className={car.soh ? s.soh : undefined}><dt>SOH baterie</dt><dd>{car.soh || "—"}</dd></div>
        </dl>

        <div className={s.foot}>
          <div>
            {/* Price without VAT is the headline figure; the VAT-inclusive price sits below */}
            <p className={s.price}>
              <span className="num">{formatPrice(priceWithoutVat(car.price))}</span>
              <span className={s.priceNote}>bez DPH</span>
            </p>
            <p className={s.vat}>
              {status === "sold" ? "Prodáno · " : status === "reserved" ? "Rezervováno · " : ""}
              s DPH <span className="num">{formatPrice(car.price)}</span>
            </p>
          </div>
          <span className={s.more} aria-hidden="true"><Icon name="arrow-right" size={18} /></span>
        </div>
      </div>
    </Link>
  );
}
